import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <div className="h-screen bg-primary flex flex-col">
      <Navbar />
      <div className="flex-1 flex flex-col">
        <Hero />
        <Footer />
      </div>
    </div>
  );
};

export default Index;